var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAstucia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1182.33 905.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#35a8e0;opacity:1.0;}.cls-2{fill:#3257a4;opacity:1.0;}.cls-3{fill:#abc7ea;}.cls-4,.cls-5{isolation:isolate;}.cls-4{opacity:1.0;}.cls-5{opacity:1.0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 1182.33,
    height: 905.45,
    rx: 84.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M953.6,434.42c-7.91-7.3-195.56-179.35-362.44-179.35S236.64,427.12,228.73,434.42a25,25,0,0,0,0,36.6c7.91,7.32,195.56,179.36,362.43,179.36S945.69,478.34,953.6,471a25,25,0,0,0,0-36.6ZM430,552.22c-63-33.31-117.66-75.71-146.25-99.49C312.37,428.94,367,386.56,430,353.24a189,189,0,0,0,0,199Zm161.13,40.11c-77,0-139.6-62.64-139.6-139.6s62.62-139.6,139.6-139.6,139.61,62.63,139.61,139.6S668.15,592.33,591.16,592.33ZM752.3,552.22a189,189,0,0,0,0-199c63,33.32,117.65,75.7,146.25,99.49C870,476.51,815.29,518.91,752.3,552.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M591.16,386.66a66.07,66.07,0,1,0,66.09,66.07A66.15,66.15,0,0,0,591.16,386.66Zm0,82.26a16.2,16.2,0,1,1,16.22-16.19A16.24,16.24,0,0,1,591.16,468.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M534.72,328.68a137,137,0,0,1,104.53-3.46h0v108Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M639.25,325.22h0c-2.67-1-5.37-1.92-8.11-2.76V425.1l8.11,8.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M639.24,325.22a137.12,137.12,0,0,1,76.37,71.46h0L639.24,473Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M715.6,396.68h0q-1.77-3.89-3.79-7.68l-72.58,72.58V473Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M715.6,396.68a137.1,137.1,0,0,1,3.47,104.53h-108Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M719.06,501.21h0q1.5-4,2.76-8.11H619.18l-8.1,8.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M719.07,501.2a137.12,137.12,0,0,1-71.46,76.37h0L571.24,501.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M647.6,577.56h0q3.89-1.77,7.68-3.79L582.71,501.2H571.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M647.61,577.56A137.1,137.1,0,0,1,543.08,581h0V473Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M543.08,581h0c2.66,1,5.37,1.92,8.11,2.76V481.14l-8.11-8.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M543.08,581a137.06,137.06,0,0,1-76.36-71.46h0l76.36-76.36V581Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M466.72,509.56h0c1.17,2.59,2.44,5.15,3.78,7.68l72.58-72.58V433.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M466.72,509.57A137,137,0,0,1,463.26,405h108Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M463.26,405h0c-1,2.66-1.92,5.37-2.76,8.11H563.14l8.11-8.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M463.26,405a137.06,137.06,0,0,1,71.46-76.36h0L611.08,405Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M534.72,328.68h0c-2.59,1.17-5.16,2.44-7.69,3.78L599.61,405h11.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M658,567.15A136.61,136.61,0,0,1,499.88,351.5a136.61,136.61,0,1,0,193,192.83A136.79,136.79,0,0,1,658,567.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M691,353.34a141.12,141.12,0,1,0,41.33,99.79A140.16,140.16,0,0,0,691,353.34Zm-47.2-21.47A133,133,0,0,1,710.2,395.7l-66.45,66.46ZM591.16,321a132.1,132.1,0,0,1,43.57,7.33v94L542.61,330.2A132,132,0,0,1,591.16,321Zm43.57,114.06v36.09l-25.52,25.52h-36.1l-25.52-25.52v-36.1l25.52-25.52h36.1Zm-137-75.37a132.33,132.33,0,0,1,36-25.62l66.46,66.45H469.91A132.11,132.11,0,0,1,497.75,359.71Zm-38.69,93.42a132.15,132.15,0,0,1,7.33-43.58h94l-92.13,92.13A132,132,0,0,1,459.06,453.13Zm79.52,121.25a133,133,0,0,1-66.46-63.84l66.46-66.45Zm52.58,10.85a132.4,132.4,0,0,1-43.57-7.33v-94l92.13,92.13A132,132,0,0,1,591.16,585.23Zm93.42-38.69a132.44,132.44,0,0,1-36,25.62l-66.45-66.45H712.42A132.11,132.11,0,0,1,684.58,546.54ZM622,496.7l92.13-92.13a133.09,133.09,0,0,1,1.85,92.13Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstucia);
export default __webpack_public_path__ + "static/media/Astucia.092ba64ffa4c75c10b09767d403412b7.svg";
export { ForwardRef as ReactComponent };